import React from 'react';
import { useAppContext } from '../../AppContext';
import { useTranslation } from 'react-i18next';

const BlockedUsersView = () => {
    const { t } = useTranslation();
    const { currentUserProfile, userProfiles, appFunctions, showConfirmation, setMessage, updateUserProfileInState } = useAppContext();
    const { httpsCallable } = useAppContext(); // Direct access to the function

    const blockedUserIds = currentUserProfile?.blockedUsers || [];
    const blockedUsers = userProfiles.filter(p => blockedUserIds.includes(p.id));

    const handleUnblock = (targetId) => {
        showConfirmation({
            message: t('settings.privacy.unblockConfirmation'),
            onConfirm: async () => {
                try {
                    const unblockUser = httpsCallable(appFunctions, 'unblockUser');
                    await unblockUser({ targetUserId: targetId });

                    // Optimistically update UI
                    const updatedBlockedUsers = currentUserProfile.blockedUsers.filter(id => id !== targetId);
                    updateUserProfileInState(currentUserProfile.id, { blockedUsers: updatedBlockedUsers });

                    setMessage(t('settings.privacy.unblockSuccess'));
                } catch (error) {
                    setMessage(t('settings.privacy.unblockError', { message: error.message }));
                }
            }
        });
    };

    return (
        <div className="mt-6 bg-gray-700 p-4 rounded-lg">
            <h3 className="font-semibold text-lg mb-3">{t('settings.privacy.blockedUsersTitle')}</h3>
            {blockedUsers.length > 0 ? (
                <div className="space-y-3 max-h-60 overflow-y-auto pr-2">
                    {blockedUsers.map(user => (
                        <div key={user.id} className="flex items-center justify-between bg-gray-800 p-3 rounded-md">
                            <div className="flex items-center gap-3">
                                <img src={user.photoURL} alt={user.displayName} className="w-10 h-10 rounded-full" />
                                <span>{user.displayName}</span>
                            </div>
                            <button
                                onClick={() => handleUnblock(user.id)}
                                className="px-3 py-1 bg-red-600 hover:bg-red-700 text-white text-sm font-bold rounded-full transition-colors"
                            >
                                {t('settings.privacy.unblockButton')}
                            </button>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-gray-400 text-sm italic">{t('settings.privacy.noBlockedUsers')}</p>
            )}
        </div>
    );
};

export default BlockedUsersView;
